import { Mumeen } from "../types/itsDetails";
import axiosInstance, { axiosFormDataInstance } from "./axiosInstance";
export interface ReceiptDetail {
  currencyCode: string;
  unitRate: number;
  units: number;
  roundoff: number;
  isSelected: boolean;
}

export interface ReceiptPayload {
  receiptNo: string;
  itsNo: string;
  muminDataId: number;
  headId: number;
  locationCode: string;
  currencyCode: string;
  unitRate: number;
  units: number;
  amount: number;
  discount: number;
  totalAmount: number;
  isApproved: boolean;
  createdByUserID: number;
  details: ReceiptDetail[];
}

export interface DraftVisaFilters {
  searchTerm?: string;
  partnerName?: string;
  officeName?: string;
  visaId?: string;
  // tourRefNo?: number;
  pageNo?: number;
  submittedpageNo?: number;
  requestMorepageNo?: number;
  isPendingpageNo?: number;
  CompletedpageNo?: number;

  pageSize?: number;
  DraftpageSize?: number;
  SubmiitedpageSize?: number;
  RequestMorepageSize?: number;
  isPendingpageSize?: number;
  CompletedpageSize?: number;

  itsNumber?: string;
  itsNo?: string;
  category?: string;
  applicationNo?: string;
  applicantName?: string;
  applicationNumber?: string;
  applicantType?: string;
  passportNo?: string;
  nationality?: string;
  status?: string;
  visaRequired?: string;
}

export interface UpdateVisaApplicationPayload {
  visaApplicationId: number;
  title: string;
  firstName: string;
  middleName: string;
  lastName: string;

  dateOfBirth: string; // ISO string

  age: number;
  gender: string;
  birthPlace: string;
  nationality: string;
  profession: string;

  applicantType: "Adult" | "Child" | "Infant" | "Senior";
  category: string;

  guardianITS: string;
  hofITS: string;

  visaRequired: boolean;
  visaNotRequiredRemark?: string | null;
  isMiqaatApplicant: boolean;

  passportNo: string;
  passportType: string;
  passportFirstName: string;
  passportMiddleName: string;
  passportLastName: string;
  passportArabicName: string;

  passportDOB?: string | null;
  passportGender: string;
  passportNationality: string;
  passportIssueDate?: string | null;
  passportExpiryDate?: string | null;
  passportIssuePlace: string;

  fatherName: string;
  fatherNameArabic: string;
  fatherITSNo: string;

  grandfatherName: string;
  grandfatherNameArabic: string;
  grandfatherITSNo: string;

  motherName: string;
  motherNameArabic: string;
  motherITSNo: string;

  mothersFatherName: string;
  mothersFatherNameArabic: string;
  mothersFatherITSNo: string;
}

export interface CreateBatchesPayload {
  visaApplicationIds: number[];
  remarks: string;
}

export interface ChangeVisaStatusPayload {
  visaApplicationId: number;
  statusCode: string;
  messageTitle?: string;
  message?: string;
  internalNote?: string;
  changedByUserId: number;
}

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// GET all Visa Data
export const AddpaxgetDetailsByITS = async (
  itsNo: string,
  force: true,
): Promise<Mumeen | null> => {
  try {
    const response = await axiosInstance.get(`/its/pax/${itsNo}?force=${force}`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getDetailsByITS = async (
  itsNo: string,
  force: true,
): Promise<Mumeen | null> => {
  try {
    const response = await axiosInstance.get(`/its/${itsNo}?force=${force}`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getViseDashboardSummary = async () => {
  try {
    // const response = await axiosInstance.get(`/visa-applications/summary`, {
    const response = await axiosInstance.get(`/visa-applications/summary/tour-operator`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getMiqaatByTourOperator = async (id: string) => {
  try {
    const response = await axiosInstance.get(`/miqaat/by-tour-operator/${id}`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

export const getViseDocument = async () => {
  try {
    const response = await axiosInstance.get(`/Documents?onlyActive=true`, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    return null;
  }
};

// JSON ONLY (draft / edit)
export const SaveVisaAppDraft = async (payload: FormData) => {
  const response = await axiosFormDataInstance.post(
    "/visa-applications/bulk",
    payload,
    {
      headers: {
        ...getAuthHeader(),
      },
    },
  );
  return response.data;
};

export const SaveWalkInVisaAppDraft = async (payload: FormData) => {
  const response = await axiosFormDataInstance.post(
    "/visa-applications/bulk/walk-in-tour",
    payload,
    {
      headers: {
        ...getAuthHeader(),
      },
    },
  );
  return response.data;
};

// FILE UPLOAD ONLY (add mode)
export const SaveVisaAppWithFiles = async (formData: FormData) => {
  return axiosFormDataInstance.post("/visa-applications/bulk", formData);
};

export const getAllDraftVisaList = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get("/visa-applications/list/draft", {
      params: {
        pageNo: filters.pageNo ?? 0,
        pageSize: filters.DraftpageSize ?? 20,
        category: filters.category || undefined,
        searchText: filters.searchTerm || undefined,
        applicantType: filters.applicantType || undefined,
        ApplicationNumber: filters.applicationNo || undefined,
        ApplicantName: filters.applicantName || undefined,
        itsNo: filters.itsNumber || undefined,
        PassportNo: filters.passportNo || undefined,
        Nationality: filters.nationality || undefined,
        StatusCode: filters.status || undefined,
        VisaRequired: filters.visaRequired || undefined,
      },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllSubmittedList = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/submitted",
      {
        params: {
          pageNo: filters.submittedpageNo ?? 0,
          pageSize: filters.SubmiitedpageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNumber || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || undefined,
          VisaRequired: filters.visaRequired || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMoreRequestList = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/request-more-info",
      {
        params: {
          pageNo: filters.requestMorepageNo ?? 0,
          pageSize: filters.RequestMorepageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNumber || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || undefined,
          VisaRequired: filters.visaRequired || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getisPendingRequestList = async (
  filters: DraftVisaFilters = {},
) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/in-progress",
      {
        params: {
          pageNo: filters.isPendingpageNo ?? 0,
          pageSize: filters.isPendingpageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNumber || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || undefined,
          VisaRequired: filters.visaRequired || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCompletedRequestList = async (
  filters: DraftVisaFilters = {},
) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/completed",
      {
        params: {
          pageNo: filters.CompletedpageNo ?? 0,
          pageSize: filters.CompletedpageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNumber || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || undefined,
          VisaRequired: filters.visaRequired || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVisaRequestedList = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/visa-requested",
      {
        params: {
          pageNo: filters.pageNo ?? 0,
          pageSize: filters.pageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNo || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || undefined,
          VisaRequired: filters.visaRequired || undefined,
          partnerName: filters.partnerName || undefined,
          officeName: filters.officeName || undefined,
          visaId: filters.visaId || undefined,
          // tourRefNo: filters.tourRefNo || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getBatchList = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get(
      "/visa-application-batches/with-applicants",
      {
        params: {
          pageNo: filters.requestMorepageNo ?? 0,
          pageSize: filters.RequestMorepageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNumber || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || "new",
          VisaRequired: filters.visaRequired || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFilterCounts = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get(
      "/visa-application-batches/batch-summary",
      {
        params: {
          searchText: filters.searchTerm || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVisaReqDashboardData = async () => {
  try {
    const response = await axiosInstance.get("/visa-applications/summary", {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStatusHistory = async (visaApplicantId: number) => {
  try {
    const response = await axiosInstance.get(
      `/visa-applications/${visaApplicantId}/status-history`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createBatchs = async (payload: CreateBatchesPayload) => {
  const response = await axiosInstance.post(
    "/visa-application-batches",
    payload,
  );
  return response.data;
};

export const getBatchApplicants = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `/visa-application-batches/${batchId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// GET Visa Application by ID
export const getVisaApplicationById = async (visaApplicationId: number) => {
  try {
    const response = await axiosInstance.get(
      `/visa-applications/${visaApplicationId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMiqaatRotationDetails = async (tourOperatorId: string, rotationId: string) => {
  try {
    const response = await axiosInstance.get(
      `/miqaat/by-tour-operator/${tourOperatorId}/rotation/${rotationId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVisaRequestedSummary = async () => {
  try {
    const response = await axiosInstance.get(
      `/visa-applications/visa-requested/summary`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDraftVisaApplication = async (
  visaApplicationId: number,
): Promise<void> => {
  await axiosInstance.delete(`/visa-applications/${visaApplicationId}/draft`, {
    headers: {
      ...getAuthHeader(),
    },
  });
};

export const getVisaCompeletedSummary = async () => {
  try {
    const response = await axiosInstance.get(
      `/visa-applications/completed/summary`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getVisaCompeletedList = async (filters: DraftVisaFilters = {}) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/visa-completed",
      {
        params: {
          pageNo: filters.pageNo ?? 0,
          pageSize: filters.pageSize ?? 20,
          category: filters.category || undefined,
          searchText: filters.searchTerm || undefined,
          applicantType: filters.applicantType || undefined,
          ApplicationNumber: filters.applicationNo || undefined,
          ApplicantName: filters.applicantName || undefined,
          itsNo: filters.itsNo || undefined,
          PassportNo: filters.passportNo || undefined,
          Nationality: filters.nationality || undefined,
          StatusCode: filters.status || undefined,
          VisaRequired: filters.visaRequired || undefined,
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export interface WalkInVisaApplicantFilters {
  searchText?: string;
  ITSNo?: string;
  ReferenceId?: string;
  PassportNo?: string;
  ApplicantName?: string;
}

export const getWalkInVisaApplicants = async (
  filters: WalkInVisaApplicantFilters = {},
) => {
  try {
    const response = await axiosInstance.get(
      "/visa-applications/list/walk-in-applicants",
      {
        params: Object.fromEntries(
          Object.entries(filters)
            .map(([key, value]) => [key, value?.trim()])
            .filter(([, value]) => value),
        ),
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadBatchCertificates = async (
  batchGuid: string,
  files: File[],
) => {
  const formData = new FormData();
  formData.append("batchId", batchGuid);
  files.forEach((file) => {
    formData.append("files", file);
  });
  const response = await axiosFormDataInstance.post(
    `/visa-applications/${batchGuid}/upload-certificates`,
    formData,
    {
      headers: {
        ...getAuthHeader(),
        "Content-Type": "multipart/form-data",
      },
    },
  );
  return response.data;
};

export const updateVisaApplication = async (
  payload: UpdateVisaApplicationPayload,
) => {
  return axiosInstance.put(
    `/visa-applications/${payload.visaApplicationId}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
    },
  );
};

// EXPORT BATCHS API
export const exportBatchDocuments = async (batchId: number) => {
  try {
    const response = await axiosInstance.get(
      `visa-application-batches/batches/${batchId}/export`,
      {
        responseType: "blob",
        headers: {
          Accept: "application/zip",
          ...getAuthHeader(),
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const NoMoreNeededBatchDocuments = async (batchGuid: string) => {
  try {
    const response = await axiosInstance.post(
      `visa-application-batches/${batchGuid}/no-more-needed`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const changeVisaApplicationStatus = async (
  visaApplicationId: number,
  payload: ChangeVisaStatusPayload, 
) => {
  const response = await axiosInstance.post(
    `/visa-applications/${visaApplicationId}/change-status`,
    payload,
    {
      headers: {
        ...getAuthHeader(),
      },
    },
  );

  return response.data as {
    success: boolean;
    message?: string;
  };
};

export const changeVisaApplicationNameDiscrepancy = async (
  visaApplicationId: number,
) => {
  const response = await axiosInstance.post(
    `/visa-applications/${visaApplicationId}/change-name-discrepancy`,
    {
      visaApplicationId,
    },
    {
      headers: {
        ...getAuthHeader(),
      },
    },
  );

  return response.data;
};

// GET Conversation
export const getVisaReviewConversation = async (visaApplicationId: number) => {
  try {
    const response = await axiosInstance.get(
      `/visa-review-conversation/${visaApplicationId}`,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

// SEND Message
export const sendVisaReviewMessage = async (payload: {
  visaApplicationId: number;
  message: string;
  isInternal: boolean;
}) => {
  try {
    const response = await axiosInstance.post(
      `/visa-review-conversation/send`,
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export interface VisaProcessingStatusPayload {
  status: "process" | "hold" | "refunded";
  remark: string;
}

export const updateVisaProcessingStatus = async (
  id: number,
  payload: VisaProcessingStatusPayload,
) => {
  try {
    const response = await axiosInstance.post<{ success: boolean; message?: string }>(
      `/visa-applications/${id}/processing-status`,
      payload,
      { headers: { ...getAuthHeader() } },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
